import { render, staticRenderFns } from "./chemical.vue?vue&type=template&id=f981371c&"
import script from "./chemical.vue?vue&type=script&lang=js&"
export * from "./chemical.vue?vue&type=script&lang=js&"
import style0 from "./chemical.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "chemical.vue"
export default component.exports